import { useState } from 'react';
import DeleteButton from '../../../../../../common/components/DeleteButton/DeleteButton';
import {hetch} from "../../../../../../utils/fetch.hooked";


function ActionButtons({ id, isActive, triggerRefetch }) {
  const [isFetching, setIsFetching] = useState(false);
  const removeItem = () => {
    setIsFetching(true);
    hetch(`/api/licenses/${id}`, {
      headers: {'Content-Type': 'application/json'},
      method: 'DELETE',
      body: null
    })
      .then(() => {
        triggerRefetch();
      })
      .finally(() => {
        setIsFetching(false);
      });
  }

  return isActive ? null : (
    <DeleteButton
      title="Удалить лицензию"
      message="Вы действительно хотите удалить лицензию?"
      isFetching={isFetching}
      onConfirm={removeItem}
    />
  );
}

export default ActionButtons;
